const styles = {
  container: {
    marginTop: '-24px',
    background: 'white',
    '&& .MuiTabs-indicator': {
      backgroundColor: '#00A1A1',
    },
    '&& div[role=tablist]': {
      backgroundColor: 'rgba(237,237,237,0.5)',
    },
    '&& div[role=tablist] > span': {
      boxShadow: '0 1px 1px 0 rgba(0,0,0,0.24), 0 1px 1.5px 0 rgba(0,0,0,0.12)',
      backgroundColor: '#00A1A1',
    },
    '&& > div': {
      boxShadow: 'none',
    },
    '&& a[role=tab]': {
      paddingTop: 0,
      paddingBottom: 0,
      fontWeight: 500,
      color: '#B2B2B2',
      fontSize: '14px',
      lineHeight: '16px',
    },
    '&& a[role=tab] > span > span': {
      padding: '16px 24px',
    },
    '&& a[aria-selected=true]': {
      color: '#00A1A1',
    },
    '&& hr': {
      display: 'none',
    },
  },
};

export default styles;
